import React from "react";
import styles from "./styles.module.scss";
import clsx from "clsx";

export default function CheckBox({
	label,
	name,
	isChecked = false,
	onChange,
	...props
}) {
	return (
		<div className={styles.checkbox}>
			<input
				{...props}
				type="checkbox"
				id={name}
				name={name}
				checked={isChecked}
				onChange={() => onChange(!isChecked)}
			/>
			<label
				className={clsx(styles.icon, { [styles.checked]: isChecked })}
				htmlFor={name}
			>
				{isChecked ? <Checked /> : <Unchecked />}
			</label>
			{label ? (
				<label htmlFor={name} className={styles.label}>
					{label}
				</label>
			) : null}
		</div>
	);
}

function Checked() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			viewBox="0 0 16 16"
		>
			<path
				fill="var(--blue)"
				d="M4.5 2A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 11.5 2zm6.354 4.854l-3.5 3.5a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7 9.293l3.146-3.147a.5.5 0 0 1 .708.708"
			/>
		</svg>
	);
}

function Unchecked() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="20"
			height="20"
			viewBox="0 0 20 20"
		>
			<path
				fill="currentColor"
				d="M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zm3-2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"
			/>
		</svg>
	);
}
